export interface AppointmentClient {
  uuid: string;
  first_name?: string;
  last_name?: string;
}

export interface Appointment {
  uuid: string;
  title: string;
  start: string;
  end: string;
  removed?: boolean;
  clients: AppointmentClient[];
}

export function clientName(client: AppointmentClient): string {
  const name = [client.first_name, client.last_name].filter(Boolean).join(' ');
  return name || 'Client';
}

/** The appointment happening now, or the next one that has not ended. */
export function selectDoorAppointment(
  appointments: Appointment[],
  now = new Date()
): { appointment: Appointment | null; happeningNow: boolean } {
  const active = appointments.filter(appointment => !appointment.removed);
  const current = active.find(
    appointment => new Date(appointment.start) <= now && now < new Date(appointment.end)
  );
  if (current) {
    return { appointment: current, happeningNow: true };
  }

  const upcoming = active
    .filter(appointment => new Date(appointment.end) > now)
    .sort((left, right) => new Date(left.start).getTime() - new Date(right.start).getTime())[0];

  return { appointment: upcoming ?? null, happeningNow: false };
}
